export const fbAppId = process.env.FB_APP_ID;
export const googleClientId = process.env.GOOGLE_CLIENT_ID;
